import { render, staticRenderFns } from "./mktDropdown.vue?vue&type=template&id=65afbc2e&"
import script from "./mktDropdown.vue?vue&type=script&lang=js&"
export * from "./mktDropdown.vue?vue&type=script&lang=js&"
import style0 from "./mktDropdown.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports